import React, { useState, useEffect } from "react";
import QRScanner from "../components/QRScanner";
import axios from "axios";
import TopBar from "../components/TopBar";
import BottomBar from "../components/BottomBar";
import { FaArrowLeft, FaSyncAlt, FaQrcode, FaKeyboard } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const CouponPage = () => {
  const [method, setMethod] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponInfo, setCouponInfo] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
  const navigate = useNavigate();

  // 🔁 ตรวจคูปองทุกครั้งที่ครบ 10 ตัวอักษร
  useEffect(() => {
    const fetchCouponInfo = async () => {
      try {
        const token = localStorage.getItem("token"); // หรือ sessionStorage แล้วแต่ที่ใช้
        const res = await axios.get(`https://api.superpetshop.com/api/v1/coupon/member?code=${couponCode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCouponInfo(res.data); // สมมุติ res.data = { discount: 50, ... }
      } catch (err) {
        setCouponInfo(null);
        alert("❌ คูปองไม่ถูกต้องหรือใช้ไปแล้ว");
      }
    };

    if (couponCode.length === 10) {
      fetchCouponInfo();
    } else {
      setCouponInfo(null);
    }
  }, [couponCode]);

  const handleScan = (text) => {
    setCouponCode(text);
    setShowScanner(false);
  };

  const handleRedeem = async () => {
    if (!couponCode || !couponInfo) {
      alert("กรุณากรอกหรือสแกนคูปองให้ถูกต้องก่อน");
      return;
    }

    try {
      const token = localStorage.getItem("token"); // หรือ sessionStorage แล้วแต่ที่ใช้
      await axios.post(`https://api.superpetshop.com/api/v1/coupon/use?code=${couponCode}`, {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      alert("✅ ใช้คูปองสำเร็จ");
      handleReset();
    } catch (err) {
      alert("เกิดข้อผิดพลาด: " + (err.response?.data?.message || err.message));
    }
  };

  const handleReset = () => {
    setMethod(null);
    setCouponCode("");
    setCouponInfo(null);
    setShowScanner(false);
  };

  const handleBack = () => {
    navigate("/menu");
  };

  return (
    <div className="flex flex-col min-h-screen">
      <TopBar />

      <div className="flex flex-col flex-1 p-4 bg-gray-100">
        <h2 className="text-lg font-bold mb-4 text-center">ใช้คูปอง</h2>

        {!method && (
          <div className="grid gap-4 mb-4 mx-8">
            <button
              className="bg-blue-500 text-white text-2xl p-4 rounded w-full mb-4 grid items-center justify-center gap-2"
              onClick={() => {
                setMethod("scan");
                setShowScanner(true);
              }}
            >
              <FaQrcode className="text-8xl" />
              สแกน QR
            </button>

            <button
              className="bg-indigo-500 text-white text-2xl p-4 rounded w-full mb-4 grid items-center justify-center gap-2"
              onClick={() => setMethod("manual")}
            >
              <FaKeyboard className="text-8xl" />
              กรอกรหัส
            </button>
          </div>
        )}

        {method === "scan" && showScanner && <QRScanner onScan={handleScan} />}

        {method === "manual" && (
          <input
            className="border p-2 w-full rounded mb-4"
            placeholder="กรอกรหัสคูปอง (10 หลัก)"
            maxLength={10}
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.replace(/[^a-zA-Z0-9]/g, ""))}
          />
        )}

        {couponInfo && (
          <div className="my-2 text-center text-green-600 font-bold text-xl">
            {couponInfo.coupon.name}
          </div>
        )}

        {method && (
          <>
            {method === "scan" && !showScanner && (
              <button
                className="bg-blue-500 text-white w-full p-2 rounded mb-4 flex items-center justify-center gap-2"
                onClick={() => {
                  setCouponCode("");
                  setCouponInfo(null);
                  setShowScanner(true);
                }}
              >
                <FaSyncAlt className="text-lg" />
                สแกนใหม่
              </button>
            )}

            <button
              className="bg-yellow-500 text-white w-full p-2 rounded mt-1 disabled:opacity-50"
              onClick={handleRedeem}
              disabled={!couponCode || !couponInfo}
            >
              ยืนยันใช้คูปอง
            </button>

            <button
              className="bg-gray-400 text-white w-full p-2 rounded mt-4"
              onClick={handleReset}
            >
              เริ่มใหม่
            </button>
          </>
        )}

        <button
          className="mt-6 text-gray-600 flex justify-center items-center gap-2 underline"
          onClick={handleBack}
        >
          <FaArrowLeft /> กลับ
        </button>
      </div>

      <BottomBar />
    </div>
  );
};

export default CouponPage;
